import * as React from 'react';
import { connect } from 'react-redux';
import './GuestLogin.css';
import { navigateTo } from '../../actions/navigationActions';
import { GUESTUSERLOGIN, LOGIN, REGISTERUSER } from '../../routes/routes';
import { signInAnon } from '../../actions/authActions';
import { showSignInModal } from '../../actions/modalActions';
import { setGuestData } from '../../actions/sspActions';
import { logEvent } from '../../firebase/firebase';
import {LOGIN_PAGE} from "../../constants/constants";

class GuestLogin extends React.PureComponent<any, any> {
    constructor(props: any) {
        super(props);
        this.state = {
            hasPolicy: undefined,
            hasAccount: undefined,
            isDisabled: true,
        };

        this.handlePolicyClick = this.handlePolicyClick.bind(this);
        this.handleAccountClick = this.handleAccountClick.bind(this);
        this.handleNextClick = this.handleNextClick.bind(this);
    }

    componentWillMount() {
        logEvent('SSP_guest_landing_page','user_landed_on_page');
        this.props.dispatchAction(navigateTo(LOGIN));
    }

    handlePolicyClick(value: boolean) {
        logEvent('SSP_does_guest_have_policy', value);
        this.setState({ hasPolicy: value });
        if (this.state.hasAccount !== undefined) {
            this.setState({ isDisabled: false });
        }
    }

    handleAccountClick(value: boolean) {
        logEvent('SSP_does_guest_have_account', value);
        this.setState({ hasAccount: value })
        if (this.state.hasPolicy !== undefined) {
            this.setState({ isDisabled: false });
        }
    }

    handleNextClick() {
        if (this.state.hasPolicy && this.state.hasAccount) {
            logEvent('SSP_guest_account_questions_complete', 'user_has_policy_and_account');
            this.props.dispatchAction(setGuestData({ showLinkAuto: true, showSaleSelectAuto: false }))
            this.props.dispatchAction(showSignInModal())
        }
        else if (!this.state.hasPolicy && this.state.hasAccount) {
            logEvent('SSP_guest_account_questions_complete', 'user_has_account_and_no_policy');
            this.props.dispatchAction(setGuestData({ showSaleSelectAuto: true, showLinkAuto: false }))
            this.props.dispatchAction(showSignInModal())
        }
        else if (this.state.hasPolicy && !this.state.hasAccount) {
            logEvent('SSP_guest_account_questions_complete', 'user_has_policy_and_no_account');
            this.props.dispatchAction(setGuestData({ showLinkAuto: true, showSaleSelectAuto: false }))
            this.props.dispatchAction(navigateTo(REGISTERUSER))
        }
        else {
            logEvent('SSP_guest_account_questions_complete', 'user_is_anonymous');
            this.props.dispatchAction(signInAnon())
        }
    }

    public render() {
        return (
            <div id="GuestContainer" className="pt-lg-5 p-lg-0 logged-out">
                <div className="col-12 mt-4 pb-4 text-lg-center text-md-center">
                    <div className="container">
                        <div className="row justify-content-center">
                            <div className="col-lg-10 col-md-12">
                                <div className="ssp-addportable-possessions-crown-icon mt-0px text-center">
                                    <div className="ssp-sales-journey-crown-icon" title="Guest login"></div>
                                </div>
                                <p className="mt-4 mb-0 text-center">Are you a King Price client?</p>
                                <div className="row">
                                    <div className="col-md-6 offset-md-3 col-lg-4 offset-lg-4 justify-content-center">
                                        <div className="row">
                                            <div className="col-md-6 pt-4 personal-info-button-holder">
                                                <button className={"btn btn-block responsive small right " + (this.state.hasPolicy === false ? "btn-solid-red" : "btn-outline-red")} id="noPolicy" onClick={() => this.handlePolicyClick(false)}>No</button>
                                            </div>
                                            <div className="col-md-6 pt-4 personal-info-button-holder">
                                                <button className={"btn btn-block  responsive small " + (this.state.hasPolicy === true ? "btn-solid-red" : "btn-outline-red")} id="hasPolicy" onClick={() => this.handlePolicyClick(true)}>Yes</button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                {this.state.hasPolicy !== undefined &&
                                    <>
                                        <p className="mt-4 mb-0 text-center">Do you have an account on our self-service portal or mobile app?</p>
                                        <div className="row pb-4">
                                            <div className="col-md-6 offset-md-3 col-lg-4 offset-lg-4 justify-content-center">
                                                <div className="row">
                                                    <div className="col-md-6 pt-4 personal-info-button-holder">
                                                        <button className={"btn btn-block  responsive small right " + (this.state.hasAccount === false ? "btn-solid-red" : "btn-outline-red")} id="guestAccount" onClick={() => this.handleAccountClick(false)}>No</button>
                                                    </div>
                                                    <div className="col-md-6 pt-4 personal-info-button-holder">
                                                        <button className={"btn btn-block  responsive small " + (this.state.hasAccount === true ? "btn-solid-red" : "btn-outline-red")} id="hasAccount" onClick={() => this.handleAccountClick(true)}>Yes</button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </>
                                }
                                {this.state.hasPolicy !== undefined && this.state.hasAccount &&
                                    <div className="noticebox mt-4 mb-4">
                                        <strong>Please note</strong><br />
                                        Because you already have an account, you will have to login to continue with this process.
                                    </div>
                                }
                                {this.state.hasPolicy !== undefined && this.state.hasPolicy && this.state.hasAccount === false &&
                                    <div className="noticebox mt-4 mb-4">
                                        <strong>Please note</strong><br />
                                        Because you’re already a KP client, you will have to sign up to our self-service portal and link your policy, before you continue to get a quote. 
                                    </div>
                                }
                                {this.state.hasPolicy !== undefined && this.state.hasAccount !== undefined &&
                                    <div className="row justify-content-center personal-info-button-holder mt-4 pt-4 pl-3 pr-3">
                                        <button className="btn btn-block btn-solid-red responsive" id="submit" onClick={this.handleNextClick} disabled={this.state.isDisabled}>Next</button>
                                    </div>
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

const mapStateToProps = (state: any) => {
    return {
        history: state.router
    }
}

const mapDispatchToProps = (dispatch: any) => {
    return {
        dispatchAction: (e) => dispatch(e)
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(GuestLogin);